import React from "react";
import * as Icons from "@material-ui/icons";
import {
  Grid,
  createStyles,
  makeStyles,
  Box,
  Fab,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  ListItemText,
} from "@material-ui/core";
import DefaultModal, {
  DefaultModalContent,
} from "../../../Components/DefaultModal";
import api from "../../../services/Api";
// import ConfirmDelete from "./ConfirmDelete";
// import NewEdit from "./Edit";
import { UserContext } from "../../../Context/UserContext";
import ConfirmDelete from "./ConfirmDelete";
import Edit from "./Edit";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: "1.5rem 0px 1rem 0px",
      margin: 0,
    },
    main: {
      minHeight: 120,
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 600,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

export const ViewModal = ({ data, setData, open, setOpen, updateData }) => {
  const classes = useStyles();
  const { privilege } = React.useContext(UserContext);
  const [select, setSelect] = React.useState(null);
  const [openView, setOpenView] = React.useState(false);

  const handleOpenView = (id) => {
    setSelect(id);
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
    setSelect(null);
  };

  const handleClose = () => {
    handleCloseView();
    setOpen();
  };

  const fullUpdate = () => {
    updateData();
  };

  const getSelectContent = React.useCallback(
    (select) => {
      switch (select) {
        case 0:
          return (
            <ConfirmDelete
              id={parseInt(data.id)}
              open={openView}
              setOpen={handleCloseView}
              handleClose={handleClose}
              updateData={fullUpdate}
            />
          );
        case 1:
          return (
            <Edit
              data={{
                id: data.id,
                tipo: data.name,
                medicao: data.medicao === "Sim" ? 1 : 0,
              }}
              setData={setData}
              open={openView}
              setOpen={handleCloseView}
              updateData={fullUpdate}
            />
          );
        default:
          return null;
      }
    },
    [select]
  );

  React.useEffect(() => {
    if (!data) {
      setOpen(false);
    }
  }, [data]);

  const formattedData = [
    {
      icon: <Icons.Description />,
      text: "Nome: ",
      data: data?.name,
    },
    {
      icon: <Icons.Straighten />,
      text: "Medição: ",
      data: data?.medicao,
    },
  ];
  return (
    <>
      {getSelectContent(select)}
      <DefaultModal
        loading={data === null}
        open={open}
        handleClose={setOpen}
        title={`Tipo de projeto`}
        actionsTitle={
          <Box>
            <Tooltip
              placement="top"
              title="Apagar tipo de projeto"
              aria-label="Apagar tipo de projeto"
            >
              <span>
                <Fab
                  size="small"
                  color="primary"
                  aria-label="edit"
                  style={{ backgroundColor: "red" }}
                  disabled={!privilege.administrator}
                  onClick={() => handleOpenView(0)}
                >
                  <Icons.Delete />
                </Fab>
              </span>
            </Tooltip>
            <Tooltip
              placement="top"
              title="Editar tipo de projeto"
              aria-label="Editar tipo de projeto"
            >
              <span>
                <Fab
                  style={{ marginLeft: "1rem" }}
                  size="small"
                  color="primary"
                  aria-label="edit"
                  disabled={!privilege.administrator}
                  onClick={() => handleOpenView(1)}
                >
                  <Icons.Edit />
                </Fab>
              </span>
            </Tooltip>
          </Box>
        }
      >
        <DefaultModalContent dividers className={classes.main}>
          <Grid container className={classes.root}>
            <Grid item xs={12}>
              <List dense disablePadding>
                {formattedData !== null &&
                  formattedData
                    .filter((r) => r.data !== null)
                    .map((value) => (
                      <ListItem alignItems="start" key={value.text}>
                        <ListItemIcon>{value.icon}</ListItemIcon>
                        <ListItemText
                          style={{
                            alignItems: "start",
                            textAlign: "start",
                            margin: 0,
                            padding: 0,
                          }}
                          primary={
                            <Typography variant="h6" component="span">
                              {value.text}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              component="span"
                              style={{ marginLeft: "0.5rem" }}
                              color="textSecondary"
                            >
                              {value.data}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Grid>
          </Grid>
        </DefaultModalContent>
      </DefaultModal>
    </>
  );
};
